import React from "react";

export default function MapLink({children}) {
  return (
    <a
      href="https://www.google.com/maps/dir//Chaveiro.24hcentro+36+anos,+Atr%C3%A1s+do+Camel%C3%B3dromo+-+R.+Francisco+Tolentino,+310+-+Centro,+Florian%C3%B3polis+-+SC,+88010-200/@-27.5935238,-48.5501598,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x95273939ae3a09a3:0xe1ed6ba5242324a2!2m2!1d-48.5535801!2d-27.5967026?entry=ttu"
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
}

